module.exports = __webpack_public_path__ + "static/img/Hussar_score_face.090add3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/Hussar_score_face.png
// module id = t14A
// module chunks = 0